import { useContext } from 'react';

import { CollapseDrawerContext } from '../contexts/CollapseDrawerContext';

const useCollapseDrawer = (): any => useContext(CollapseDrawerContext);

export default useCollapseDrawer;
